<template>
  <MainTab v-if="registration" main-title="Informazioni pacchetto">
    <ContentWrapper>
      <TicketPackage
        :registration="registration"
        @completeSurvey="completeSurvey($event)"
        @downloadFiles="downloadFiles($event)"
        @editLaboratories="editLaboratories($event)"
      ></TicketPackage>
      <Modal
        class="dea-modal--survey-reminder dea-modal--no-footer"
        :visible="showModal"
        :is-error="false"
        @modalClose="showModal = false"
      >
        <template #title>Completa il questionario</template>
        <template #content>
          <div class="dea-heading--medium__ms">Per visualizzare i materiali completa prima il questionario.</div>
        </template>
      </Modal>
    </ContentWrapper>
    <router-link :to="{ name: 'events', params: { ticketFilter: 'past', updateRegistrations: true } }">
      <Links class="dea-links--large dea-links--generic-dark-grey">Torna ai corsi</Links>
    </router-link>
  </MainTab>
  <Loader v-else></Loader>
</template>

<script>
import { mapActions } from "vuex";
import Links from "@/components/elements/Links";
import Loader from "@/components/elements/Loader";
import Modal from "@/components/patterns/Modal";
import ContentWrapper from "~/components/events/components/ContentWrapper";
import MainTab from "~/components/events/components/MainTab";
import TicketPackage from "~/components/events/components/TicketPackage.vue";

export default {
  name: "EventsPackage",
  components: {
    ContentWrapper,
    MainTab,
    TicketPackage,
    Links,
    Loader,
    Modal,
  },
  data() {
    return {
      registration: undefined,
      showModal: false,
    };
  },
  mounted() {
    const registrationId = this.$route.params.registration;
    if (registrationId) {
      this.getPackage(registrationId);
    }
  },
  methods: {
    ...mapActions(["fetchBundleData"]),
    async getPackage(id) {
      this.registration = await this.fetchBundleData(id);
    },
    completeSurvey(registration) {
      this.$router.push({ name: "personal-data", params: { registration: registration.id } });
    },
    downloadFiles(registration) {
      if (registration.survey_completed_date || (registration.bundle_parent && registration.is_event_attended)) {
        this.$router.push({ name: "download", params: { registration: registration.id } });
      } else {
        this.showModal = true;
      }
    },
    editLaboratories(registration) {
      this.$router.push({ name: "laboratories", params: { registration: registration.id } });
    },
  },
};
</script>

<style lang="scss"></style>
